import React from 'react';
import { ArrowDownRight, Star } from 'lucide-react';
import { company } from '../data/company';
const stats = [{
  value: '100%',
  label: 'Recommended'
}, {
  value: '6+',
  label: 'Five-star reviews'
}, {
  value: '8',
  label: 'Cities served'
}];
export function Hero() {
  return <section id="top" className="bg-ink" data-id="element-75" data-mp="4lyv8luf2edn">
      <div className="mx-auto max-w-6xl px-6 pb-16 pt-16 lg:pb-20 lg:pt-24" data-id="element-76" data-mp="4n1jem0cu2pv">
        <div className="grid gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:items-end" data-id="element-77" data-mp="129qwps0ic1r1">
          <div data-id="element-78" data-mp="xanq434vpngy">
            <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-gold" data-id="element-79" data-mp="xa4ipgcuuhh6">
              <Star className="h-3.5 w-3.5 fill-gold" aria-hidden="true" data-id="element-80" data-mp="sa9n4zi4x3ps" />
              Salem, Oregon · Family owned
            </p>
            <h1 className="mt-7 text-[2.75rem] font-semibold leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-[4.25rem]" data-id="element-81" data-mp="neax77h5rdn9">
              Your home,
              <span className="block text-gold" data-id="element-82" data-mp="381e1dbzoc3ti">back to bright.</span>
            </h1>
            <p className="mt-7 max-w-md text-lg leading-relaxed text-white/70" data-id="element-83" data-mp="3j896f9neq5ny">
              Roof moss, siding, windows, driveways, and decks — washed with the
              right pressure for the surface, by the crew the valley keeps
              recommending.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-84" data-mp="3e95ztkrs3rdv">
              <a href="#quote" className="inline-flex items-center gap-2 bg-gold px-7 py-4 text-sm font-bold uppercase tracking-[0.08em] text-ink transition-colors hover:bg-gold-dark" data-id="element-85" data-mp="3ebiqcmblra2j">
                Get a free estimate
                <ArrowDownRight className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="2ql69glydq2zt" />
              </a>
              <a href={company.phoneHref} className="text-sm font-semibold text-white underline decoration-gold decoration-2 underline-offset-[6px] hover:text-gold" data-id="element-87" data-mp="2vjzo4hpek01k">
                or call {company.phone}
              </a>
            </div>
          </div>

          <div className="relative" data-id="element-88" data-mp="s2te9nr9cdqs">
            <img src={company.heroImage} alt="Stone and siding home with a freshly washed paver driveway in Salem, Oregon" className="aspect-[4/3] w-full object-cover lg:aspect-[4/5]" data-id="element-89" data-mp="s44e5chl11cm" />
            <div className="absolute bottom-0 left-0 max-w-[15rem] bg-ink px-5 py-4" data-id="element-90" data-mp="ddwwgyzefmcz">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-gold" data-id="element-91" data-mp="1b0nmhzkkal84">
                Recent job
              </p>
              <p className="mt-1.5 text-sm text-white/80" data-id="element-92" data-mp="16344qponnqbf">
                Tile roof, siding, and paver driveway — cleaned in a single
                visit.
              </p>
            </div>
          </div>
        </div>

        <dl className="mt-16 grid grid-cols-3 border-t border-ink-line pt-8" data-id="element-93" data-mp="x0uyic0f6j3u">
          {stats.map(stat => <div key={stat.label} data-id="element-94" data-mp="3lqm25xlrf3ue">
              <dd className="text-3xl font-semibold tracking-tight text-white sm:text-4xl" data-id="element-95" data-mp="3hqtz20f4xpwf">
                {stat.value}
              </dd>
              <dt className="mt-2 font-mono text-[10px] uppercase tracking-[0.18em] text-white/45" data-id="element-96" data-mp="1xb5q6f7x0tgn">
                {stat.label}
              </dt>
            </div>)}
        </dl>
      </div>
    </section>;
}